export default __webpack_public_path__ + "static/media/cfdShortImg.e7bc1bb7.webp";